
import React, { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import CartButton from '@/components/navbar/CartButton';
import { ShopifyCartDrawer } from '@/components/shopify/ShopifyCartDrawer';
import AuthLinks from '@/components/ui/auth-links';
import { useAdminStatus } from '@/hooks/auth/useAdminStatus';
import LanguageSwitcher from '@/components/navbar/LanguageSwitcher';

const AdminButton = lazy(() => import('@/components/navbar/AdminButton'));

interface NavbarActionsProps {
  cartCount: number;
  children: React.ReactNode;
}

const NavbarActions = ({ cartCount, children }: NavbarActionsProps) => {
  const { isAdmin } = useAdminStatus();
  const location = useLocation();
  const isShopifyRoute = location.pathname.startsWith('/shopify');

  return (
    <div className="flex items-center space-x-4 ml-4 md:ml-0">
      <LanguageSwitcher />

      
      {isShopifyRoute ? <ShopifyCartDrawer /> : <CartButton cartCount={cartCount} />}
      
      <AuthLinks />
      
      {/* Only show admin settings button for admin user */}
      {isAdmin && <Suspense fallback={null}><AdminButton /></Suspense>}
      
      {/* Mobile menu toggle */}
      {children}
    </div>
  );
};

export default NavbarActions;
